import SearchFilter from '../../../../atoms/SearchFilter';

const ConsumerSearch = ({ value, onChange }: { value: string; onChange: (value: string) => void }) => (
  <SearchFilter value={value} onChange={onChange} placeholder="Buscar consumidor" className="w-64" />
);

export default ConsumerSearch;
